import { BlockDataForm } from '@plone/volto/components/manage/Form';
import PropTypes from 'prop-types';

import { listingSelectionSchema } from './schema';

const ListingSelectionData = (props) => {
  const { data, block, onChangeBlock, blocksErrors } = props;
  const schema = listingSelectionSchema({ ...props });
  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeBlock={onChangeBlock}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
      errors={blocksErrors}
    />
  );
};

ListingSelectionData.propTypes = {
  data: PropTypes.shape({
    size: PropTypes.string,
    spacing: PropTypes.string,
  }),
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
};

export default ListingSelectionData;
